export default __webpack_public_path__ + "static/media/info-box-cores.0ad9fab6.svg";